import './Viewproductsubcategory.css';
import { useState ,useEffect } from 'react';
import axios from 'axios';
import { _subcategoryapiurl } from '../../Api.url';
import{Link, useParams} from 'react-router-dom'

function Viewproductsubcategory()
{
   const params =useParams();
    const [scDetails ,setSubCategoryDetails]=useState([]);
    useEffect(()=>{
        axios.get(_subcategoryapiurl+"fetch?catnm="+params.catnm).then((response)=>{
          setSubCategoryDetails(response.data);  
        }).catch((error)=>{
          console.log(error);   
        });
      }); 


    return(
        <>
        <br/><br/>
          {/* About Start */}
          <div class="container-xxl py-5">
            <div class="container">
                <div class="row g-5 align-items-center">
                    <div class="col-lg-12 wow fadeInUp" data-wow-delay="0.1s">
                        <h1 class="mb-4" style={{"color":"#15b9d9"}}>View  Sub Category List {params.catnm}</h1>
                        <hr/>

                       <center>
                        <div id="category_main"> 
                            {
                                scDetails.map((row)=>(
                                <div class="category_part">
                                <Link to={`/viewp/${row.subcatnm}`}>
                                 <img src={`../assets/uploads/subcaticons/${row.subcaticonnm}`}height="115"width="240"/>
                                 <br/>
                                 <b>{row.subcatnm}</b>
                                 </Link>
                                </div>
                               
                                ))
                            }
                        </div>
                        </center>
                        
                     

                    </div>
                </div>
            </div>
        </div>
       
        {/* About End */}


        </>
    );

}

export default Viewproductsubcategory;